const getPcoList ="/mhp/record/getPcoList";
const getSqlGroup ="/mhp/record/getSqlGroup";
const getSqlList ="/mhp/record/getSqlList";
const getHttpRecordList ="/mhp/record/getHttpRecordList";  

export default {
    getPcoList,getSqlGroup,getSqlList,getHttpRecordList
  }